import { Vehicle } from "../../DataStructures/Vehicle/Vehicle";
import { Trip } from "../../DataStructures/Trip/Trip";
import * as moment from 'moment';
import { TimeCounter } from "./TimeCounter";
import { VehicleReserves } from "./VehicleReserves";
import { VehiclePool } from "./VehiclePool";

import { ReusableVehicles } from "./ReusableVehicles";
import { DriverShift } from "../../DataStructures/Shift/DriverShift";
import { VehicleReservation } from "../../DataStructures/VehicleReservation/VehicleReservation";
import { Schedule } from "./Schedule";
import { Week } from "../../DataStructures/Week/Week";
import { DateConstants } from "../WeekSchedule/DateConstants";
import { Decision, QuickDialog } from "../Dialog/QuickDialog";
import { MatDialog } from "@angular/material";
import { MainService } from "../../services/optimizer-service/optimizer.service";
import { Area } from "../../DataStructures/Area/Area";
import { RunConfig } from "../../DataStructures/RunConfiguration/RunConfig";
import { VehicleSuggestion } from "../VehicleSuggestion/VehicleSuggestion";
import { VehicleService } from "../../services/vehicle-service/vehicle.service";

export class VehicleScheduler {

    schedules = new Map<string, Array<Vehicle>>();
    reserves: VehicleReserves



    constructor(initialVehicles: Array<Vehicle>, round = 0) {
        var reservations = new Array<VehicleReservation>();
        initialVehicles.forEach(v => {
            reservations.push(new VehicleReservation(v));
        });
        this.reserves = new VehicleReserves(reservations);


    }
    generateSchedules(): Array<Schedule> {
        var schedules: Array<Schedule> = [];

        this.schedules.forEach((value, key) => {

            schedules.push(new Schedule(key, value));
        });

        var reserve = new Schedule("reserves", this.reserves.getVehicles());

        schedules.push(reserve);

        return schedules;
    }

    getReservationForVehicle(vehicleId): VehicleReservation {
        return this.reserves.getReservationForVehicle(vehicleId);
    }

    getReservationsForVehicles(vehicles: Array<Vehicle>): Array<VehicleReservation> {
        var reservations = [];
        vehicles.forEach(v => {

            reservations.push(this.getReservationForVehicle(v.vehicleid));
        });

        return reservations;
    }

    addVehiclesToReservers(vehicles: Array<Vehicle>) {
        var reservations = new Array<VehicleReservation>();

        vehicles.forEach(v => {
            reservations.push(new VehicleReservation(v));
        });

        this.reserves.addReservations(reservations);
    }

    getAvailableVehiclesForTime(key: string): VehiclePool {
        
        /* THIS BODY OF CODE COUNTS BACKWARDS FOR 24 HOURS TO FIND DRIVERS THE CAN BE REUSED.
        THE SCHEDULES OBJECT IS A MAP THAT WILL HAVE THE NEXT TIME THE DRIVER WILL BE AVAILABLE
        BASED ON HIS RETURN TIME FROM HIS LAST TRIP. ANYTHING WE FIND IN THE MAP WE CAN CLASSIFY
        AS A REUSABLE DRIVER. (25 IS USED IN THE COUNTER OTHEWISE ITS A BUG WHERE THE LAST DRIVER
            IS NOT DETECTED, INVESTIGATION NEEDED) 
        */
        var reusables = [];
        var counter = new TimeCounter(moment(new Date(key)), 25);
        var k = null;
        while ((k = counter.lastHour()) != -1) {


            var v = this.schedules.get(k);
            if (v != null) {
                reusables = reusables.concat(v);
            }

        }
        /////////

        var vehiclesAvailableForTime = [];
        this.reserves.getVehicles().forEach(r => {

            //If its a contracted vehicle no need to check the shift
            if (r.make == "CONTRACTED" && r.model == "CONTRACTED") {
                vehiclesAvailableForTime.push(r)
            } else {
                //If its a actual driver then check the drivers shift
                r.shifts.forEach(s => {
                    var driverShift = new DriverShift(s);
                    var hours = driverShift.getRange();
                    var hourInQuestion = moment(key).format('dddd hh:mm A');
                    var match = hours.find(h => h.format('dddd hh:mm A') == hourInQuestion);
                    if (match) {
                        vehiclesAvailableForTime.push(r);
                    }
                })
            }
        });


        var reservationsForTime = this.getReservationsForVehicles(vehiclesAvailableForTime);
        var reusableReservations = this.getReservationsForVehicles(reusables);

        return new VehiclePool(new VehicleReserves(reservationsForTime), new ReusableVehicles(reusableReservations));
    }

    computeSchedule(trips: Array<Trip>) {
        var allowedWaitTime = 20;
        trips.forEach(t => {

            //Because all areas in the trip are now the same time
            var date = moment(t.slotTime).toDate();

            var exactTimeVehicleWillBeAvailable = t.vehicleReservation.getTimeVehicleWillBeAvailableAfterTrip(t);
            var vehicle = t.vehicleReservation.vehicle;

            this.removeVehicleFromReserves(vehicle);
            this.removeVehicleFromSchedule(vehicle);
            var minutes = exactTimeVehicleWillBeAvailable.minutes();

            if (minutes > allowedWaitTime) {
                var key = Trip.createSubTripKey(exactTimeVehicleWillBeAvailable.add(1, 'h').startOf('hour'));
            } else {
                var key = Trip.createSubTripKey(exactTimeVehicleWillBeAvailable.startOf('hour'));
            }

            var shiftEnded = VehicleScheduler.driverShiftEnded(vehicle, key);
            if (!shiftEnded) {
                //Executes if the drivers shift has not ended
                if (this.schedules.get(key) == null) {

                    var vehicles = new Array<Vehicle>();
                    vehicles.push(vehicle);
                    this.schedules.set(key, vehicles);

                } else {
                    this.schedules.get(key).push(vehicle);
                }
            }
        });
    }

    public static driverShiftEnded(vehicle: Vehicle, key: string): boolean {
        var result = true;
        if (vehicle.make == "CONTRACTED" && vehicle.model == "CONTRACTED") {
            return false;
        } else {
            var s = null;
            for(var i = 0; i < vehicle.shifts.length;i++){
                s = vehicle.shifts[0];
                var shift = new DriverShift(s);
                var hours = shift.getRange();
                var hourInQuestion = moment(key).format('dddd hh:mm A');
                var match = hours.find(h => h.format('dddd hh:mm A') == hourInQuestion);
                if (match) {
                    result = false;
                    break;
                }
            }
        }
        return result;
    }


    private removeVehicleFromSchedule(vehicle: Vehicle) {
        this.schedules.forEach(vehiclesArray => {

            var foundVehicle = vehiclesArray.find(v => v.vehicleid == vehicle.vehicleid);
            var index = vehiclesArray.indexOf(foundVehicle);
            if (index != -1) {
                vehiclesArray.splice(index, 1);
            }
        });
    }

    private removeVehicleFromReserves(vehicle: Vehicle) {
        this.reserves.removeVehicle(vehicle.vehicleid);
    }

    /**
     * Returns all the trips who use the same vehicle as the source trip and come afer the source trip.
     * Essentially these trips depart time and vehicle depend on the source trip.
     */
    public static getDependentTrips(week:Week,sourceTrip:Trip){
        var day = week.getDayForTrip(sourceTrip);
        var tripsAfterHour = day.getTripsAfterHour(sourceTrip.getTripSlotTime());
        var dependentTrips : Array<Trip> = [];
        tripsAfterHour.forEach((trips,key) =>{
            var t = trips.find(x => x.vehicleReservation.vehicle.vehicleid == sourceTrip.vehicleReservation.vehicle.vehicleid);
            if(t){
                dependentTrips.push(t);
            }
        });
        return dependentTrips;
    }

    public static getNextTripDepartTime(week:Week,sourceTrip:Trip){
        var trips = this.getDependentTrips(week,sourceTrip);
        if(trips.length > 0){
            return trips[0].getDepartTimeRaw();
        }else{
            return null;
        }
    }

    public static updateSchedule(week:Week,sourceTrip:Trip){
        var affected = this.getDependentTrips(week,sourceTrip);
        affected.forEach(t =>{
            var found = t.vehicleReservation.tripsAndWaitTimes.find(x => x.tripId == sourceTrip.id);
            if(found){
                found.tripTime = sourceTrip.time;
            }
        });
    }


    /**
     * This function call calculateDirections on the trip and checks if the trip time increases or decreases. 
     * If the trip time increases so as to throw off the depart time of
     * all other trips that share that vehicle then the depart time of those trips will be increased by X units of time.
     * If the trip time decreases all other trips that share that vehicle will have a decrease in its depart time by X units of time
     * but no lower than its original depart time. 
     * @param week 
     * @param sourceTrip 
     * @param dialog 
     * @returns 
     */
    public static async handleTripTimeChange(
        week:Week,
        sourceTrip:Trip, 
        revertSatate:Array<Area>,
        optimizerService:MainService,
        runConfig:RunConfig,
        vehicleService:VehicleService,
        dialog:MatDialog):Promise<{choice:string,affected:Array<Trip>}>{
        var affectedTrips = this.getDependentTrips(week,sourceTrip);
        var nextTripDepartTime = VehicleScheduler.getNextTripDepartTime(week,sourceTrip);
        await sourceTrip.calculateDirections(optimizerService);
        if(nextTripDepartTime){
            if(sourceTrip.getArrivalTimeRaw()  > nextTripDepartTime){
                var diffInMins = sourceTrip.getArrivalTimeRaw().diff(affectedTrips[0].getDepartTimeRaw(),'minute');
                var decision:Decision = {
                    message:`Doing this adds a ${diffInMins} minute delay to all ${affectedTrips.length} trips this vehicle is assigned to`,
                    options:[
                        {
                            icon:'fa-check',
                            code:'delay',
                            message:'Allow Delay'
                        },
                        {
                            icon:'fa-ban',
                            code:'cancel',
                            message:'Cancel'
                        }
                    ]
                }
                var choice = await new QuickDialog(dialog).DecisionDialog(decision,'400px');
                if(choice == 'cancel'){
                    sourceTrip.areas = revertSatate;
                    await sourceTrip.calculateDirections(optimizerService);
                }else if(choice == 'new'){
                    var suggestion = new VehicleSuggestion(vehicleService,runConfig);
                    var res = await suggestion.getSuggestions([sourceTrip]);
                    res[0].vehicleReservation.assignToNewTrip(sourceTrip);
                    VehicleScheduler.updateSchedule(week,sourceTrip);
                }else if(choice == 'delay'){
                    VehicleScheduler.updateSchedule(week,sourceTrip);
                }
                else if(choice == 'ok'){
                    VehicleScheduler.updateSchedule(week,sourceTrip);
                }
                return {
                    choice:choice,
                    affected:affectedTrips
                }
            }else{
                return {
                    choice:'ok',
                    affected:affectedTrips
                }
            }
        }else{
            return {
                choice:'ok',
                affected:affectedTrips
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/utilities/Scheduling/VehicleScheduler.ts